import { render, staticRenderFns } from "./TeacherCategoryModal.vue?vue&type=template&id=35231ecc&scoped=true"
import script from "./TeacherCategoryModal.vue?vue&type=script&lang=js"
export * from "./TeacherCategoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35231ecc",
  null
  
)

export default component.exports